import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Services.css";
import Insurance from "./Insurance";
import Loans from "./Loans";
import FraudWarning from "./FraudWarning"; 
import MutualSip from "./MutualSip";

export default function Services() {
  const location = useLocation();

  const scrollToSection = (id) => {
    const section = document.querySelector(`#${id}`);
    if (!section) return;

    const yOffset = -80; // header irundhaa adjust pannalaam
    const y =
      section.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  // Scroll to section if navigated from CircularSlider
  useEffect(() => {
    if (location.state?.scrollTo) {
      // Use setTimeout to ensure DOM is rendered before scrolling
      const timer = setTimeout(() => {
        scrollToSection(location.state.scrollTo);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <section className="services-page">
      {/* HERO */}
      <div
        className="services-hero"
        style={{ backgroundImage: "url(/oursservicess.jpg)" }}
      >
      
      </div>

      {/* 3 SERVICE CARDS */}
      <div className="services-cards">
        <div
          className="service-box"
          onClick={() => scrollToSection("insurance")}
        >
          <h3>Insurance</h3>
          <img src="/icons/r2.png" alt="Insurance" />
        </div>

        <div
          className="service-box"
          onClick={() => scrollToSection("loans")}
        >
          <h3>Loans</h3>
          <img src="/icons/r3.png" alt="Loans" />
        </div>

        <div
          className="service-box"
          onClick={() => scrollToSection("mutual")}
        >
          <h3>Mutual Fund & SIP</h3>
          <img src="/icons/loan88.png" alt="SIP" />
        </div>
      </div>

      {/* SECTIONS */}
      <Insurance />
      <Loans />
      <MutualSip />
            {/* ===== FRAUD / IRDAI WARNING SECTION ===== */}
       {/* 🔹 FRAUD / IRDAI WARNING */}

          <FraudWarning />
    </section>
      
  );
}
